export default () => {
  const config = useRuntimeConfig()
  
  const postSubscribe = (email, token) => {
    try {
      return useFetch('/api/database/subscribe', {
        method: 'POST',
        body: JSON.stringify({
          token,
          email,
        }),
      })
    } catch (error) {
      console.log(error)
    }
  }

  return {
    postSubscribe,
  }
}
